var _path, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6380_16450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 8.49999L3.60602 9.43999L7.33268 5.71999V13.8333H8.66602V5.71999L12.386 9.44666L13.3327 8.49999L7.99935 3.16666L2.66602 8.49999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6380_16450)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.66602,
    y: -8.16666,
    width: 33.3333,
    height: 33.3333,
    fill: "#6D6E71"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6380_16450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -9,
    width: 34,
    height: 35
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -8.66602,
    y: -8.16666,
    width: 33.3333,
    height: 33.3333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6380_16450)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortInactive);
export default __webpack_public_path__ + "static/media/sort-inactive.452a587fee5954f74bd0e29386b6f89c.svg";
export { ForwardRef as ReactComponent };